import AboutUsComponent from '../components/about-us/about-us'

const AboutUs = () => <AboutUsComponent />

export default AboutUs;